let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("76n7a"), load("l253H"), load("JZq07")]).then(() => parcelRequire('fEx2J'));